import { faFacebookF, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();

function Footer({ style }) {
    return (
        <footer className={`footer ${style ? 'dark-mode' : ""}`}>
            
            <Container>
                <Row className="justify-content-between">
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/images/logo-light.webp" alt="م/ محمود عبدالوهاب"/>
                            </div>
                            <p className="footer-description">
                                منصة تعليمية متخصصة في الماث تحت إشراف م/ محمود عبدالوهاب  
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={8} md={6} className="mb-4">
                        <div className="footer-section">
                            <h5>تواصل معنا</h5>
                            <div className="social-links">
                                <Link to="https://youtube.com/@mahmoudmohamed-fz8kg?si=CmAJW8U7-zLSM8Fk" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </Link>
                                <Link to="https://www.tiktok.com/@thepuzzleacademy1?_r=1&_t=ZS-93PvFFUbobx" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <FontAwesomeIcon icon={faTiktok} />
                                </Link>
                                <Link to="https://www.facebook.com/share/1Am16ZPNEc/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <div className="footer-bottom">
                    <div className="powered-by">
                        <span>Powered by </span>
                        <Link to="https://www.facebook.com/profile.php?id=61556333871338" target="_blank" rel="noopener noreferrer">ReachX</Link>
                    </div>
                    <div className="copyright">
                        <span>Developed by</span> 
                        <Link to="https://www.facebook.com/said.sayed.3386" target="_blank" rel="noopener noreferrer">Said</Link> , 
                        <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank" rel="noopener noreferrer">Nassef</Link> 
                        <span> All Copy Rights Reserved © {currentYear}</span>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;